<div class="md-radio-container" [ngClass]="{'cursor-pointer' : !isDisabled}">
    <input type="radio" id="{{id || random}}" [(ngModel)]="model" *ngIf="value" value="{{value}}" (change)="this.modelChange.emit(this.model);">
    <input type="radio" id="{{id || random}}" [(ngModel)]="model" *ngIf="!value" (change)="this.modelChange.emit(this.model);">
    <label class="flex-row align-items-center gap-1" for="{{id || random}}">
        <span class="marker flex-shrink-0"></span>
        <span class="f-1-0"><ng-content></ng-content></span>
    </label>
</div>
